import { mapActions } from 'vuex';

import { getMenu } from '@/api/menu';
import CancelOrder from '@/components/CancelOrder/CancelOrder.vue';
import OrderBlock from '@/components/OrderBlock/OrderBlock.vue';
import bus from '@/utils/bus';
import { RECEIVE_STATUS, SNACKBAR_TYPES } from '@/utils/constants';
import { ERROR_RECORD_NOT_FOUND } from '@/utils/errorCodeList';

export default {
  name: 'MemberOrders',
  components: {
    CancelOrder,
    OrderBlock,
  },
  props: {
    orders: {
      default: () => [],
      type: Array,
    },
    orderName: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      showCancelOrderDialog: false,
      uuid: '',
    };
  },
  computed: {
    ordersTotal() {
      return this.orders?.reduce((total, { order_contents: items = [], status }) => {
        if (status === RECEIVE_STATUS.CANCELED) {
          return total;
        }
        const orderTotal = items.reduce((acc, { subtotal = 0 }) => acc + subtotal, 0);
        return total + orderTotal;
      }, 0) ?? 0;
    },
  },
  created() {
    bus.$on('CANCEL_ORDER_SUCCESS', async () => {
      this.getCurrentMenu();
    });
  },
  methods: {

    ...mapActions('menu', {
      getMenu: 'GET_MENU',
    }),
    cancelOrder({ uuid }) {
      this.showCancelOrderDialog = true;
      this.uuid = uuid;
    },
    async getCurrentMenu() {
      try {
        const id = this.$route?.params?.id;

        if (!id) {
          const error = new Error();
          error.status = ERROR_RECORD_NOT_FOUND;
          throw error;
        }
        await this.getMenu({
          cb: getMenu,
          key: id,
        });
      } catch (error) {
        const { message: msg = '找不到團購', status } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          msg,
        });
        if (status === ERROR_RECORD_NOT_FOUND) {
          this.$router.replace('/menu');
        }
      }
    },
  },
};
